export default {
  upgrade: {
    en: 'Upgrade',
  },
  upgradeYourPlan: {
    en: 'Upgrade your plan',
  },
}
